export interface Statistics {
  accounted: number
  debited: number
  remaining_time_to_annulate: number
  bonus: number
  promocodesCount: number
  ordersCount: number
  rank: number
  cashback: number
}

export enum DeliveryType {
  SMS = 'sms',
  CALL = 'call',
}

export enum Sex {
  MALE = 'm',
  FEMALE = 'f',
}

export interface Info {
  birthday: string
  email: string
  fullName: string
  mobile: string
  mobile_formatted: string
  receiveEmail: boolean
  receiveMobilePush: boolean
  receiveSms: boolean
  receiveWebPush: boolean
  sex: Sex | string
  clientId: string
  clientHash: string
  referralPromocodes: ReferralPromocode[]
}

export interface Code {
  code_length: number
  deliveredBy: DeliveryType
  waitSeconds: number
}

export interface UserStatistics {
  accounted: number
  debited: number
  remaining_time_to_annulate: number
  bonus: number
  promocodesCount: number
  ordersCount: number
  rank: number
  cashback: number
}

export interface RequestData {
  code: string
  phone: string
}

export interface ConfirmCode extends UserInfo {
  client_id: string
  client_hash: string
}

export interface UserInfo {
  birthday: string
  email: string
  fullName: string
  mobile: string
  mobile_formatted: string
  receiveEmail: boolean
  receiveMobilePush: boolean
  receiveSms: boolean
  receiveWebPush: boolean
  sex: Sex | string
  clientId: string
  clientHash: string
  referralPromocodes: ReferralPromocode[]
}

export interface ChangeUserInfoDTO {
  email?: string
  full_name?: string
  birthday?: string
  sex?: string
  receive_sms?: boolean
  receive_email?: boolean
  receive_web_push?: boolean
  receive_mobile_push?: boolean
}

export interface ReferralPromocode {
  referral_rule_id: number
  description_for_referral: string
  description_for_referrer: string
  value: string
  enabled: boolean
  date_from: string
  date_to: string
}

export interface SignIn extends UserInfo {
  client_id: string
  client_hash: string
}

export interface RequestCode {
  code_length: number
  delivered_by: DeliveryType
  wait_seconds: number
}

export interface UserMenuItem {
  title: string
  path: string
}

export const SESSION_ID_COOKIE = 'sessionid'
export const VARIOQUB_USER_ID_COOKIE = '_ymab_param'
